import { render, staticRenderFns } from "./orderShopCom.vue?vue&type=template&id=7da1d4ec&scoped=true"
import script from "./orderShopCom.vue?vue&type=script&lang=js"
export * from "./orderShopCom.vue?vue&type=script&lang=js"
import style0 from "./orderShopCom.vue?vue&type=style&index=0&id=7da1d4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da1d4ec",
  null
  
)

export default component.exports